import React from 'react';
import {
  NotificationOutlined,
  SettingOutlined,
  StarOutlined,
  SwapOutlined,
  TagOutlined
} from '@ant-design/icons';

import { FEATURES } from 'appConstants';
import { useFeatureFlags } from 'hooks';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import { TOrbit } from '../../../i18n/TModules';
import SelectionTile, { TileRow } from '../components/SelectionTile';
import { TRIGGER_KINDS, TriggerKind } from '../wizardModel';

const ACTION_ICON: Record<TriggerKind, React.ReactNode> = {
  transaction: <SwapOutlined />,
  loyalty: <StarOutlined />,
  milestone: <NotificationOutlined />,
  reward: <TagOutlined />,
  others: <SettingOutlined />
};

interface IActionTilesProps {
  selected: TriggerKind | null;
  onSelect: (kind: TriggerKind) => void;
  /** The Add Task picker wraps the tiles three to a row (6778:22346). */
  columns?: number;
}

/**
 * 6778:17978's five earn actions. A transaction trigger needs the module's own
 * `transaction_rule_trigger` flag, as the rule form's trigger picker does.
 */
const ActionTiles: React.FC<IActionTilesProps> = ({ selected, onSelect, columns }) => {
  const { t } = useMultiLanguageTranslation();
  const flags = useFeatureFlags();
  const kinds = TRIGGER_KINDS.filter(
    kind => kind !== 'transaction' || flags[FEATURES.TRANSACTION_RULE_TRIGGER.key] === true
  );
  return (
    <TileRow $columns={columns}>
      {kinds.map(kind => (
        <SelectionTile
          key={kind}
          icon={ACTION_ICON[kind]}
          label={t(`${TOrbit}.wizard.action.${kind}`)}
          selected={selected === kind}
          onSelect={() => onSelect(kind)}
          testId="orbit-wizard-action-tile"
        />
      ))}
    </TileRow>
  );
};

export default ActionTiles;
